module.exports = __webpack_public_path__ + "assets/images/favicons/favicon-96x96.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favicons/favicon-96x96.png
// module id = 856
// module chunks = 0